import { Grid } from "@mantine/core"
import { SuperAdminBookingTabs } from "src/components/superadmin/bookings/SuperAdminBookingTabs"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { formatDate, formatTime } from "src/utils/dates"
import { BookingStatusMachine } from "src/components/bookings"
import { TalentAdminBookingView } from "src/components/talent/bookings/TalentAdminBookingView"
import { TalentAdminBookingGuidelineActions } from "src/components/talent/bookings/guidelines/TalentAdminBookingGuidelineActions"

export function TalentAdminBooking() {

    const { currentItem } = useAppState(state => state.bookings)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.talent_id ? currentItem.talent?.dj_display : 'Unassigned'} @ ${currentItem?.venue?.name}, ${formatDate(currentItem?.date, 'M/d')} ${!!currentItem?.set_start_time ? '- ' : ''}${formatTime(currentItem?.set_start_time)}`}
                />
            }
        >
            <SuperAdminBookingTabs />

            <Grid>
                <Grid.Col span={{ base: 12, md: 4 }}>
                    <BookingStatusMachine
                        showStatusBadge={true}
                        showDescriptions={true}
                        buttonSize="xs"
                        spacing="md"
                    />
                    <TalentAdminBookingGuidelineActions />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 8 }}>
                    <TalentAdminBookingView />
                </Grid.Col>
            </Grid>

        </DrawerPageLayout>
    )

}